/**
 * @generated SignedSource<<7549d922c65df9ccb6032279343e44a9>>
 * @relayHash 44db9f450e28b26d3fd0636099f11bcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f26dec82fc176d621569044513f48281be3108ad88f94424ece034aa9b3aef45

import type { ConcreteRequest } from 'relay-runtime';
export type FavouriteButtonComponentQuery$variables = {
  contentId: string;
};
export type FavouriteButtonComponentQuery$data = {
  readonly contentOperations: {
    readonly id: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
  } | null;
  readonly singleContent: {
    readonly id: string | null;
    readonly metadata: {
      readonly currentuser: {
        readonly favourited: {
          readonly isFavourite: boolean | null;
        } | null;
      } | null;
    };
    readonly type: string | null;
  } | null;
};
export type FavouriteButtonComponentQuery = {
  response: FavouriteButtonComponentQuery$data;
  variables: FavouriteButtonComponentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "args": (v1/*: any*/),
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "type"
      },
      {
        "concreteType": "ContentMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentMetadata_CurrentUserMetadataProvider_currentuser",
            "kind": "LinkedField",
            "name": "currentuser",
            "plural": false,
            "selections": [
              {
                "concreteType": "FavouritedSummary",
                "kind": "LinkedField",
                "name": "favourited",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "alias": "contentOperations",
    "args": (v1/*: any*/),
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "operation"
          },
          {
            "kind": "ScalarField",
            "name": "targetType"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FavouriteButtonComponentQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FavouriteButtonComponentQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "44db9f450e28b26d3fd0636099f11bcf",
    "id": "f26dec82fc176d621569044513f48281be3108ad88f94424ece034aa9b3aef45",
    "metadata": {},
    "name": "FavouriteButtonComponentQuery",
    "operationKind": "query",
    "text": "query FavouriteButtonComponentQuery($contentId:ID!){singleContent(id:$contentId){id,type,metadata{currentuser{favourited{isFavourite}}}},contentOperations:singleContent(id:$contentId){id,operations{operation,targetType}}}"
  }
};
})();

(node as any).hash = "c0d9982d75aa14c419a4e3cb6fb450f1";

export default node;
